import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { InputOutline, TextareaComponent } from "@sxm-content-creators/tools-ds";
import { AiGroup, SCORE_BANDS } from "../theme-ai/ai-config.group";

/** Max length of the audio-energy label. */
export const AUDIO_ENERGY_LABEL_MAX = 40;
/** Max length of any scoring / detection / score-band criteria prompt. */
export const EVALUATION_CRITERIA_MAX = 1000;

/**
 * "AI Evaluation" tab of the theme form. Merges scoring & detection rules (T-6 — spam detection +
 * audio-energy label/criteria) and score bands (T-7 — one criteria prompt per backend score band)
 * into a single component so the tab mounts one child like every other tab. Score-band labels are
 * the backend boundaries (authoritative per the 2026-08-12 BE-8 decision) and the pill colors reuse
 * the producer dashboard's bad→elite ramp (CREATORS-29817). Bound to the shared parent-owned
 * `AiGroup`; this component only reads/mutates that group.
 */
@Component({
    selector: "app-theme-ai-evaluation",
    templateUrl: "./theme-ai-evaluation.component.html",
    styleUrl: "./theme-ai-evaluation.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ReactiveFormsModule, NgClass, InputOutline, TextareaComponent]
})
export class ThemeAiEvaluationComponent {
    /** Parent-owned AI group; this component only reads/mutates it. */
    readonly ai = input.required<AiGroup>();

    protected readonly bands = SCORE_BANDS;
    protected readonly labelMaxLength = AUDIO_ENERGY_LABEL_MAX;
    protected readonly criteriaMaxLength = EVALUATION_CRITERIA_MAX;
}
